// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gate-wrap {
  max-width: 560px;
  margin: 0 auto;
  padding: 24px 16px;
  text-align: center;
}

.gate-eyebrow {
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 12px;
}

.gate-card {
  background: #fff;
  border: 1px solid #d7e6e3;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 6px 24px rgba(15, 118, 110, 0.08);
}

.gate-english {
  font-size: 24px;
  font-weight: 700;
  color: #183b3b;
  margin: 0 0 8px;
  line-height: 1.35;
}

.gate-translit {
  color: #637878;
  font-style: italic;
  margin: 0 0 4px;
}

.gate-meaning {
  color: #486363;
  margin: 0 0 20px;
}

.gate-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.gate-btn {
  padding: 10px 18px;
  border-radius: 10px;
  border: 1px solid #0f766e;
  background: #fff;
  color: #0f766e;
  font-weight: 700;
  cursor: pointer;
  font-size: 15px;
}

.gate-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.gate-btn-primary {
  background: #0f766e;
  color: #fff;
}

.gate-heard {
  color: #486363;
  margin: 12px 0 0;
}

.gate-feedback {
  margin: 12px 0 0;
  font-weight: 700;
}

.gate-feedback-fail {
  color: #b91c1c;
}

.gate-feedback-pass {
  color: #0f766e;
}

.gate-success {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.gate-error {
  color: #b91c1c;
}

.gate-hint {
  margin-top: 16px;
  color: #94a3a3;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/features/Games/ProverbGate/proverbGate.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".gate-wrap {\n  max-width: 560px;\n  margin: 0 auto;\n  padding: 24px 16px;\n  text-align: center;\n}\n\n.gate-eyebrow {\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin: 0 0 12px;\n}\n\n.gate-card {\n  background: #fff;\n  border: 1px solid #d7e6e3;\n  border-radius: 16px;\n  padding: 28px 24px;\n  box-shadow: 0 6px 24px rgba(15, 118, 110, 0.08);\n}\n\n.gate-english {\n  font-size: 24px;\n  font-weight: 700;\n  color: #183b3b;\n  margin: 0 0 8px;\n  line-height: 1.35;\n}\n\n.gate-translit {\n  color: #637878;\n  font-style: italic;\n  margin: 0 0 4px;\n}\n\n.gate-meaning {\n  color: #486363;\n  margin: 0 0 20px;\n}\n\n.gate-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.gate-btn {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: 1px solid #0f766e;\n  background: #fff;\n  color: #0f766e;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n.gate-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.gate-btn-primary {\n  background: #0f766e;\n  color: #fff;\n}\n\n.gate-heard {\n  color: #486363;\n  margin: 12px 0 0;\n}\n\n.gate-feedback {\n  margin: 12px 0 0;\n  font-weight: 700;\n}\n\n.gate-feedback-fail {\n  color: #b91c1c;\n}\n\n.gate-feedback-pass {\n  color: #0f766e;\n}\n\n.gate-success {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.gate-error {\n  color: #b91c1c;\n}\n\n.gate-hint {\n  margin-top: 16px;\n  color: #94a3a3;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
